'use strict';

const BlobUploader = require('common/ui/view/blob/uploader');
const BlobListView = require('common/ui/view/blob/list');
const BlobSelectorTemplate = require('common/ui/template/blob/selector.hbs');
require('backbone.stickit');

module.exports = Backbone.View.extend({
    initialize: function(params) {
        _.bindAll(this, 'select', 'successUpload');
        this._blobs = params.blobs;
        this._imageOnly = params.imageOnly;
        this._multiple = params.multiple;
        this._useUploader = params.useUploader;
        this._blobApi = params.blobApi;
        this.on('remove', this.onRemove);
    },

    render: function() {
        this.$el.html(BlobSelectorTemplate({
            multiple: this._multiple,
        }));

        const blobListView = new BlobListView({
            blobs: this._blobs,
            imageOnly: this._imageOnly,
            multiple: this._multiple
        });
        this.$('.blob-list-view').append(blobListView.render().$el);

        if(this._useUploader) {
            const uploader = new BlobUploader({
                blobApi: this._blobApi,
                imageOnly: this._imageOnly,
                onSuccess: this.successUpload
            });

            this.$('.uploader').append(uploader.render().$el);
        }

        this.listenTo(this._blobs, 'activate', this.setSelectState);
        this.listenTo(this._blobs, 'deactivate', this.setSelectState);

        return this;
    },

    select: function() {
        return new Promise((resolve, reject) => {
            const blobs = this._blobs.filter(function(blob) {
                return blob.isActive();
            });
            this._blobs.each((blob) => {
                blob.deactivate();
            });
            if(blobs.length > 0) {
                if(this._multiple) {
                    resolve(blobs);
                } else {
                    // multiple が false なら複数選択されることはないはず
                    resolve(blobs[0]);
                }
            }else{
                //何も選択されていない
                reject();
            }
        });
    },

    setSelectState: function() {
        if(this._blobs.find(function(blob){return blob.isActive()})) {
            this.trigger('formFilled');
        } else {
            this.trigger('formEmpty');
        }
    },

    successUpload: function(file, blob) {
        this._blobs.add(blob);
        blob.activate();
    },

    deactivateExcept: function(blob) {
        this._blobs.each(function(b) {
            if(b.id != blob.id) {
                b.deactivate();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./common/ui/view/blob/selector.js